// Клиент для `/api/public/wells` — каталог скважин личного кабинета публичного
// юзера (OSDU Well, средний уровень онтологии Field→Well→Wellbore).
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts).
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/well.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.

import type { WellDto } from '@webtypes/WellDto'
import type { CreateWellBody } from '@webtypes/CreateWellBody'
import type { UpdateWellBody } from '@webtypes/UpdateWellBody'
import { crudClient } from './crudClient'

export type { WellDto, CreateWellBody, UpdateWellBody }
// 409 = скважина используется (FK ON DELETE RESTRICT — когда wellbore начнёт
// ссылаться на well); страница ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<WellDto, CreateWellBody, UpdateWellBody>(
  '/api/public/wells',
  'Скважина используется — удалить нельзя',
)

export const listWells = client.list
export const createWell = client.create
export const updateWell = client.update
export const deleteWell = client.remove
